import moment from 'moment-timezone';

export const replaceNumber = (str) => str?.replace(/[^0-9]/g, '') || '';
export const replaceNumberFloatingPoint = (str) => {
  if (!str) {
    return '';
  }
  const tmpStr = str.replace(',', '.').replace(/[^0-9.]/g, '');
  const firstIndPoint = str.indexOf('.');

  return firstIndPoint > -1
    ? `${tmpStr.substring(0, firstIndPoint)}.${tmpStr.substring(firstIndPoint).replace(/\./g, '')}`
    : tmpStr;
};

export const declOfNum = (n, one, two, five) => {
  n = Math.abs(n) % 100;
  const n1 = n % 10;
  if (n > 10 && n < 20) return five;
  if (n1 > 1 && n1 < 5) return two;
  if (n1 === 1) return one;
  return five;
};

export const dateFormatToMoscowTime = (date, format = 'DD.MM.YYYY HH:mm:ss') => {
  if (!date) {
    return 'Invalid date';
  }
  return moment.utc(date).tz('Europe/Moscow').format(format);
};
